import qs from 'qs';

import axiosInstance from '../protected';

import {IPageable, IPageableDto} from '../../shared/types/pageable.types';

import {getAccountGroupsUrl} from '../api.config';
import {
  IAccountGroup,
  IAccountGroupPostBody,
  IAccountGroupSpec,
  IUsersAndGroupsSearchSpec,
} from '../../shared/types/user-account-groups.types';
import {IUserAccount} from '../../shared/types/user-account.types';

export const AccountGroupsService = {
  async getAll(
    attr: {
      pageable?: IPageable;
      spec?: IAccountGroupSpec;
    } = {},
  ) {
    const res = await axiosInstance.get<IPageableDto<IAccountGroup>>(getAccountGroupsUrl(), {
      params: {
        ...attr.pageable,
        ...attr.spec,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return res;
  },

  async getById(id: number) {
    const res = await axiosInstance.get<IPageableDto<IAccountGroup>>(getAccountGroupsUrl(), {
      params: {
        ids: [id],
      },
    });

    return res;
  },

  async getGroupUsers(id: number) {
    const res = await axiosInstance.get<IUserAccount[]>(getAccountGroupsUrl(`/${id}/users`));

    return res;
  },

  // добавление пользователей к текущему составу
  async addGroupUsers(id: number, accountIds: number[]) {
    const res = await axiosInstance.put<IUserAccount[]>(
      getAccountGroupsUrl(`/${id}/users`),
      {},
      {
        params: {
          accountIds,
        },
        paramsSerializer: {
          serialize: (params) => {
            return qs.stringify(params, {arrayFormat: 'repeat'});
          },
        },
      },
    );

    return res;
  },

  // полная замена всего состава пользователей
  async replaceGroupUsers(id: number, accountIds: number[]) {
    const res = await axiosInstance.post<IUserAccount[]>(
      getAccountGroupsUrl(`/${id}/users`),
      {},
      {
        params: {
          accountIds,
        },
        paramsSerializer: {
          serialize: (params) => {
            return qs.stringify(params, {arrayFormat: 'repeat'});
          },
        },
      },
    );

    return res;
  },

  async deleteGroupUsers(id: number, accountIds: number[]) {
    const res = await axiosInstance.delete<IUserAccount[]>(getAccountGroupsUrl(`/${id}/users`), {
      params: {
        accountIds,
      },
      paramsSerializer: {
        serialize: (params: Record<string, any>) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return res;
  },

  async update(data: IAccountGroup) {
    const updated = await axiosInstance.put<IAccountGroup>(getAccountGroupsUrl(), data);

    return updated;
  },

  async delete(id: number) {
    await axiosInstance.delete(getAccountGroupsUrl(`/${id}`));
  },

  async deleteAFew(IDs: number[]) {
    const deleted = await axiosInstance.delete<number[]>(getAccountGroupsUrl(), {
      params: {
        id: IDs,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return deleted;
  },

  async create(data: IAccountGroupPostBody) {
    const created = await axiosInstance.post<IAccountGroup>(getAccountGroupsUrl(), data);

    return created;
  },

  async findByIDs(IDs: number[]) {
    const res = await axiosInstance.post<IAccountGroup[]>(getAccountGroupsUrl(`/findByIDs`), IDs);

    return res;
  },

  async usersOrGroups<T>(spec: IUsersAndGroupsSearchSpec) {
    const res = await axiosInstance.get<T>(getAccountGroupsUrl('/usersOrGroups'), {
      params: spec,
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return res;
  },
};
